import app from '@/app';

/* @ngInject */
function Built($resource) {
	return $resource(
		'api/builts/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Built', Built);
